import Consumer from "./Consumer";
import Fuse from "./Fuse";
import RelationOneToMany from "./RelationOneToMany";

export default class RelationConsumerToFuse extends RelationOneToMany<Fuse> {
  get toClassNames(): Array<string> {
    return ["Fuse"]; // no itx
  }

  constructor(from: Consumer) {
    super({
      from: from,
      fromClassName: "Consumer",
      backReferencePropertyName: "consumers",
    });
  }
}
